/**
 * Inline Sizing Guide for ear tips
 * Multi-step wizard with logic-based size recommendation
 */
(function () {
  const SIZING_GUIDE_SELECTOR = '.sizing-guide-inline';
  const TRIGGER_SELECTOR = '.sizing-guide-inline__trigger';

  function findVariantInput(variantSelects, sizeValue) {
    const fieldset = variantSelects.querySelector('fieldset[data-handle="size"]') ||
      Array.from(variantSelects.querySelectorAll('fieldset')).find((fs) => {
        const inputs = fs.querySelectorAll('input[type="radio"]');
        return Array.from(inputs).some((inp) =>
          /small|medium|large|assorted/i.test(inp.value)
        );
      });
    if (!fieldset) return null;

    const inputs = fieldset.querySelectorAll('input[type="radio"]');
    const sizeLower = (sizeValue || '').toLowerCase();

    for (const inp of inputs) {
      const val = (inp.value || '').toLowerCase();
      if (sizeLower === 'assorted' && val.includes('assorted')) return inp;
      if (sizeLower === 'small' && (val === 'small' || val.startsWith('small'))) return inp;
      if (sizeLower === 'medium' && (val === 'medium' || val.startsWith('medium'))) return inp;
      if (sizeLower === 'large' && (val === 'large' || val.startsWith('large'))) return inp;
    }
    return null;
  }

  function getRecommendation(answers) {
    const silicone = answers.silicone;
    const comfort = answers.comfort;

    if (silicone === 'different-per-ear' || comfort === 'different-per-ear') return 'Assorted';
    if (silicone === 'idk') return 'Assorted';

    const sizeMap = { small: 0, medium: 1, large: 2 };
    let idx = sizeMap[silicone];
    if (idx === undefined) return 'Assorted';

    if (comfort === 'loose' || comfort === 'loosen') {
      idx = Math.min(2, idx + 1);
    } else if (comfort === 'tight') {
      idx = Math.max(0, idx - 1);
    }

    const sizes = ['Small', 'Medium', 'Large'];
    return sizes[idx];
  }

  function init() {
    document.querySelectorAll(TRIGGER_SELECTOR).forEach((trigger) => {
      if (trigger.dataset.sizingGuideInit) return;
      trigger.dataset.sizingGuideInit = '1';

      const sectionId = trigger.dataset.sectionId;
      const container = document.getElementById(`sizing-guide-inline-${sectionId}`);
      if (!container) return;

      const steps = container.querySelectorAll('.sizing-guide-inline__step');
      const prevBtn = container.querySelector('[data-prev]');
      const nextBtn = container.querySelector('[data-next]');
      const options = container.querySelectorAll('.sizing-guide-inline__option');
      const resultContainer = container.querySelector('[data-result-container]');
      const recommendationText = container.querySelector('[data-recommendation-text]');
      const applyBtn = container.querySelector('[data-apply-recommendation]');
      const explanations = container.querySelectorAll('.sizing-guide-inline__explanation[data-explanation]');

      const answers = { silicone: null, comfort: null };
      let currentStep = 1;

      function showStep(stepNum) {
        steps.forEach((s) => {
          const n = parseInt(s.dataset.step, 10);
          s.hidden = n !== stepNum;
        });
        currentStep = stepNum;

        prevBtn.hidden = stepNum <= 1;
        nextBtn.hidden = stepNum === 3 || (stepNum === 2 && !answers.silicone);

        if (stepNum === 3) {
          const rec = getRecommendation(answers);
          if (recommendationText) {
            recommendationText.textContent = `We recommend: ${rec}. Select below to apply.`;
          }
          if (applyBtn) applyBtn.dataset.recommendation = rec;
          if (resultContainer) resultContainer.hidden = false;

          const recLower = rec.toLowerCase();
          explanations.forEach((el) => {
            const key = el.dataset.explanation;
            el.hidden = key !== recLower;
          });
        }
      }

      function goNext() {
        if (currentStep === 2 && answers.silicone && answers.comfort) {
          showStep(3);
        } else if (currentStep < 3) {
          showStep(currentStep + 1);
        }
      }

      function goPrev() {
        if (currentStep > 1) showStep(currentStep - 1);
      }

      trigger.addEventListener('click', () => {
        const expanded = trigger.getAttribute('aria-expanded') === 'true';
        container.hidden = expanded;
        container.dataset.focused = expanded ? 'false' : 'true';
        trigger.setAttribute('aria-expanded', !expanded);
        if (!expanded) {
          currentStep = 1;
          answers.silicone = null;
          answers.comfort = null;
          showStep(1);
          options.forEach((o) => o.classList.remove('selected'));
        }
      });

      options.forEach((opt) => {
        opt.addEventListener('click', () => {
          const step = parseInt(opt.closest('.sizing-guide-inline__step')?.dataset.step, 10);
          opt.closest('.sizing-guide-inline__step')?.querySelectorAll('.sizing-guide-inline__option').forEach((o) => o.classList.remove('selected'));
          opt.classList.add('selected');

          if (step === 1) answers.silicone = opt.dataset.value;
          if (step === 2) answers.comfort = opt.dataset.value;

          if (step === 2) {
            setTimeout(() => showStep(3), 300);
          } else if (step === 1) {
            setTimeout(() => showStep(2), 300);
          }
        });
      });

      if (prevBtn) prevBtn.addEventListener('click', goPrev);
      if (nextBtn) nextBtn.addEventListener('click', goNext);

      applyBtn?.addEventListener('click', () => {
        const rec = applyBtn.dataset.recommendation;
        if (!rec) return;

        const variantSelects = document.getElementById(`variant-selects-${sectionId}`);
        if (!variantSelects) return;

        const input = findVariantInput(variantSelects, rec);
        if (input) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        container.hidden = true;
        container.dataset.focused = 'false';
        trigger.setAttribute('aria-expanded', 'false');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
